import { Box, BoxProps, withStyles } from '@material-ui/core';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import React from 'react';
import cn from 'classnames';

interface DataRowProps extends BoxProps {
  isLast?: boolean;
}

export const DataRow = withStyles(({ palette, spacing }) => ({
  root: {
    width: '100%',
    borderBottom: `1px solid ${palette.grey[200]}`,
    padding: spacing(2, 0),
    '&.isLast': {
      borderBottom: 0,
    },
  },
}))(({ isLast = false, ...otherProps }: DataRowProps) => (
  <Box {...otherProps} className={cn({ isLast })} />
));

export const Caption = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(2),
    '&:after': {
      content: '":"',
    },
  },
}))(FsBody);

export const Value = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(2),
  },
}))(FsBodyBold);

export const ValueSmall = withStyles(({ palette }) => ({
  root: {
    color: palette.grey[300],
  },
}))(FsBodySmall);
